import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Bicycle Interactions questions
export const bicycleInteractionsMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-bi-1',
    text: {
      en: 'You approach an intersection with a bicycle crossing. A cyclist is waiting to cross. What should you do?',
      nl: 'Je nadert een kruising met een fietsoversteekplaats. Een fietser wacht om over te steken. Wat moet je doen?',
      ar: 'أنت تقترب من تقاطع مع معبر دراجات. راكب دراجة ينتظر العبور. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-1o1',
        text: {
          en: 'Stop and give way to the cyclist',
          nl: 'Stop en geef voorrang aan de fietser',
          ar: 'توقف وأعط الأولوية لراكب الدراجة'
        }
      },
      {
        id: 'q-bi-1o2',
        text: {
          en: 'Continue driving, cyclists must wait',
          nl: 'Blijf rijden, fietsers moeten wachten',
          ar: 'استمر في القيادة، يجب على راكبي الدراجات الانتظار'
        }
      },
      {
        id: 'q-bi-1o3',
        text: {
          en: 'Honk to warn the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتحذير راكب الدراجة'
        }
      }
    ],
    correctAnswerId: 'q-bi-1o1',
    explanation: {
      en: 'At bicycle crossings, motorists must stop and give way to cyclists who are waiting to cross or already crossing.',
      nl: 'Bij fietsoversteekplaatsen moeten automobilisten stoppen en voorrang verlenen aan fietsers die wachten om over te steken of al aan het oversteken zijn.',
      ar: 'عند معابر الدراجات، يجب على السائقين التوقف وإعطاء الأولوية لراكبي الدراجات الذين ينتظرون العبور أو يعبرون بالفعل.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-2',
    text: {
      en: 'You want to turn right at an intersection. A cyclist is approaching from the opposite direction, also turning right. Who has priority?',
      nl: 'Je wilt rechtsaf slaan op een kruising. Een fietser nadert van de tegenovergestelde richting en slaat ook rechtsaf. Wie heeft voorrang?',
      ar: 'تريد الانعطاف يمينا عند تقاطع. راكب دراجة يقترب من الاتجاه المعاكس، وينعطف يمينا أيضا. من له الأولوية؟'
    },
    options: [
      {
        id: 'q-bi-2o1',
        text: {
          en: 'The cyclist has priority',
          nl: 'De fietser heeft voorrang',
          ar: 'راكب الدراجة له الأولوية'
        }
      },
      {
        id: 'q-bi-2o2',
        text: {
          en: 'You have priority as a motorist',
          nl: 'Je hebt voorrang als automobilist',
          ar: 'لديك الأولوية كسائق'
        }
      },
      {
        id: 'q-bi-2o3',
        text: {
          en: 'Whoever arrives first has priority',
          nl: 'Wie het eerst aankomt heeft voorrang',
          ar: 'من يصل أولا له الأولوية'
        }
      }
    ],
    correctAnswerId: 'q-bi-2o1',
    explanation: {
      en: 'Cyclists have priority when turning right at intersections. Motorists must give way to cyclists in this situation.',
      nl: 'Fietsers hebben voorrang bij rechtsaf slaan op kruisingen. Automobilisten moeten in deze situatie voorrang verlenen aan fietsers.',
      ar: 'راكبو الدراجات لهم الأولوية عند الانعطاف يمينا عند التقاطعات. يجب على السائقين إعطاء الأولوية لراكبي الدراجات في هذه الحالة.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-3',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane. What is the minimum distance you must maintain when overtaking?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad. Wat is de minimumafstand die je moet aanhouden bij inhalen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات. ما هي المسافة الدنيا التي يجب أن تحافظ عليها عند التجاوز؟'
    },
    options: [
      {
        id: 'q-bi-3o1',
        text: {
          en: '1 meter',
          nl: '1 meter',
          ar: '1 متر'
        }
      },
      {
        id: 'q-bi-3o2',
        text: {
          en: '1.5 meters',
          nl: '1,5 meter',
          ar: '1.5 متر'
        }
      },
      {
        id: 'q-bi-3o3',
        text: {
          en: '2 meters',
          nl: '2 meter',
          ar: '2 متر'
        }
      }
    ],
    correctAnswerId: 'q-bi-3o2',
    explanation: {
      en: 'When overtaking cyclists, you must maintain a minimum distance of 1.5 meters to ensure their safety.',
      nl: 'Bij het inhalen van fietsers moet je een minimumafstand van 1,5 meter aanhouden om hun veiligheid te waarborgen.',
      ar: 'عند تجاوز راكبي الدراجات، يجب عليك الحفاظ على مسافة دنيا تبلغ 1.5 متر لضمان سلامتهم.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-4',
    text: {
      en: 'You are driving in a 30 km/h zone. A cyclist is riding ahead of you at 20 km/h. What should you do?',
      nl: 'Je rijdt in een 30 km/u zone. Een fietser rijdt voor je met 20 km/u. Wat moet je doen?',
      ar: 'أنت تقود في منطقة 30 كم/س. راكب دراجة يركب أمامك بسرعة 20 كم/س. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-4o1',
        text: {
          en: 'Overtake immediately when safe',
          nl: 'Haal onmiddellijk in wanneer het veilig is',
          ar: 'تجاوز فورا عندما يكون آمنا'
        }
      },
      {
        id: 'q-bi-4o2',
        text: {
          en: 'Follow behind at a safe distance',
          nl: 'Volg achter op een veilige afstand',
          ar: 'اتبع من الخلف على مسافة آمنة'
        }
      },
      {
        id: 'q-bi-4o3',
        text: {
          en: 'Honk to make the cyclist move faster',
          nl: 'Toeter om de fietser sneller te laten gaan',
          ar: 'استخدم البوق لجعل راكب الدراجة يتحرك أسرع'
        }
      }
    ],
    correctAnswerId: 'q-bi-4o2',
    explanation: {
      en: 'In 30 km/h zones, you should follow cyclists at a safe distance rather than overtaking, as the speed difference is minimal.',
      nl: 'In 30 km/u zones moet je fietsers op een veilige afstand volgen in plaats van in te halen, omdat het snelheidsverschil minimaal is.',
      ar: 'في مناطق 30 كم/س، يجب عليك متابعة راكبي الدراجات على مسافة آمنة بدلا من التجاوز، لأن فرق السرعة ضئيل.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-5',
    text: {
      en: 'You are parking your car. You see a bicycle lane next to the parking space. What should you do?',
      nl: 'Je parkeert je auto. Je ziet een fietspad naast de parkeerplaats. Wat moet je doen?',
      ar: 'أنت تركن سيارتك. ترى ممر دراجات بجانب مكان الوقوف. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-5o1',
        text: {
          en: 'Park normally, cyclists can go around',
          nl: 'Parkeer normaal, fietsers kunnen eromheen',
          ar: 'اركن بشكل طبيعي، راكبو الدراجات يمكنهم الدوران'
        }
      },
      {
        id: 'q-bi-5o2',
        text: {
          en: 'Check for cyclists before opening your door',
          nl: 'Controleer op fietsers voordat je je deur opent',
          ar: 'تحقق من راكبي الدراجات قبل فتح بابك'
        }
      },
      {
        id: 'q-bi-5o3',
        text: {
          en: 'Park closer to the bicycle lane to save space',
          nl: 'Parkeer dichter bij het fietspad om ruimte te besparen',
          ar: 'اركن أقرب إلى ممر الدراجات لتوفير المساحة'
        }
      }
    ],
    correctAnswerId: 'q-bi-5o2',
    explanation: {
      en: 'Always check for approaching cyclists before opening your car door when parking next to a bicycle lane to prevent accidents.',
      nl: 'Controleer altijd op naderende fietsers voordat je je autodeur opent bij het parkeren naast een fietspad om ongevallen te voorkomen.',
      ar: 'تحقق دائما من راكبي الدراجات القادمين قبل فتح باب سيارتك عند الوقوف بجانب ممر الدراجات لمنع الحوادث.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-6',
    text: {
      en: 'You are driving on a road without a bicycle lane. A cyclist is riding on the right side of the road. What should you do?',
      nl: 'Je rijdt op een weg zonder fietspad. Een fietser rijdt aan de rechterkant van de weg. Wat moet je doen?',
      ar: 'أنت تقود على طريق بدون ممر دراجات. راكب دراجة يركب على الجانب الأيمن من الطريق. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-6o1',
        text: {
          en: 'Drive as close as possible to the cyclist',
          nl: 'Rijd zo dicht mogelijk bij de fietser',
          ar: 'اقترب قدر الإمكان من راكب الدراجة'
        }
      },
      {
        id: 'q-bi-6o2',
        text: {
          en: 'Maintain a safe distance and overtake when possible',
          nl: 'Houd een veilige afstand en haal in wanneer mogelijk',
          ar: 'حافظ على مسافة آمنة وتجاوز عندما يكون ذلك ممكنا'
        }
      },
      {
        id: 'q-bi-6o3',
        text: {
          en: 'Honk to make the cyclist move to the side',
          nl: 'Toeter om de fietser naar de zijkant te laten gaan',
          ar: 'استخدم البوق لجعل راكب الدراجة يتحرك إلى الجانب'
        }
      }
    ],
    correctAnswerId: 'q-bi-6o2',
    explanation: {
      en: 'When there is no bicycle lane, cyclists have the right to use the road. Maintain a safe distance and overtake only when it is safe to do so.',
      nl: 'Wanneer er geen fietspad is, hebben fietsers het recht om de weg te gebruiken. Houd een veilige afstand en haal alleen in wanneer het veilig is om dat te doen.',
      ar: 'عندما لا يوجد ممر دراجات، لراكبي الدراجات الحق في استخدام الطريق. حافظ على مسافة آمنة وتجاوز فقط عندما يكون ذلك آمنا.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-7',
    text: {
      en: 'You are approaching a roundabout. A cyclist is already in the roundabout. What should you do?',
      nl: 'Je nadert een rotonde. Een fietser rijdt al op de rotonde. Wat moet je doen?',
      ar: 'أنت تقترب من دوار. راكب دراجة موجود بالفعل في الدوار. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-7o1',
        text: {
          en: 'Enter the roundabout, cyclists must give way',
          nl: 'Rijd de rotonde op, fietsers moeten voorrang verlenen',
          ar: 'ادخل الدوار، يجب على راكبي الدراجات إعطاء الأولوية'
        }
      },
      {
        id: 'q-bi-7o2',
        text: {
          en: 'Wait for the cyclist to exit the roundabout',
          nl: 'Wacht tot de fietser de rotonde verlaat',
          ar: 'انتظر حتى يغادر راكب الدراجة الدوار'
        }
      },
      {
        id: 'q-bi-7o3',
        text: {
          en: 'Enter and overtake the cyclist immediately',
          nl: 'Rijd de rotonde op en haal de fietser onmiddellijk in',
          ar: 'ادخل وتجاوز راكب الدراجة فورا'
        }
      }
    ],
    correctAnswerId: 'q-bi-7o2',
    explanation: {
      en: 'At roundabouts, you must give way to traffic already in the roundabout, including cyclists.',
      nl: 'Bij rotondes moet je voorrang verlenen aan verkeer dat al op de rotonde rijdt, inclusief fietsers.',
      ar: 'عند الدوارات، يجب عليك إعطاء الأولوية للمرور الموجود بالفعل في الدوار، بما في ذلك راكبي الدراجات.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-8',
    text: {
      en: 'You are driving on a narrow road. A cyclist is approaching from the opposite direction. What should you do?',
      nl: 'Je rijdt op een smalle weg. Een fietser nadert van de tegenovergestelde richting. Wat moet je doen?',
      ar: 'أنت تقود على طريق ضيق. راكب دراجة يقترب من الاتجاه المعاكس. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-8o1',
        text: {
          en: 'Continue driving, the cyclist must move aside',
          nl: 'Blijf rijden, de fietser moet opzij gaan',
          ar: 'استمر في القيادة، يجب على راكب الدراجة التحرك جانبا'
        }
      },
      {
        id: 'q-bi-8o2',
        text: {
          en: 'Slow down and give the cyclist extra space',
          nl: 'Vertraag en geef de fietser extra ruimte',
          ar: 'أبطئ وأعط راكب الدراجة مساحة إضافية'
        }
      },
      {
        id: 'q-bi-8o3',
        text: {
          en: 'Stop completely and let the cyclist pass',
          nl: 'Stop volledig en laat de fietser passeren',
          ar: 'توقف تماما واسمح لراكب الدراجة بالمرور'
        }
      }
    ],
    correctAnswerId: 'q-bi-8o2',
    explanation: {
      en: 'On narrow roads, slow down and give cyclists extra space when passing to ensure their safety.',
      nl: 'Op smalle wegen moet je vertragen en fietsers extra ruimte geven bij het passeren om hun veiligheid te waarborgen.',
      ar: 'على الطرق الضيقة، أبطئ وأعط راكبي الدراجات مساحة إضافية عند المرور لضمان سلامتهم.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-9',
    text: {
      en: 'You are driving at night. You see a cyclist ahead without proper lighting. What should you do?',
      nl: 'Je rijdt \'s nachts. Je ziet een fietser voor je zonder goede verlichting. Wat moet je doen?',
      ar: 'أنت تقود ليلا. ترى راكب دراجة أمامك بدون إضاءة مناسبة. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-9o1',
        text: {
          en: 'Flash your headlights to warn the cyclist',
          nl: 'Knipper met je koplampen om de fietser te waarschuwen',
          ar: 'ومض مصابيحك لتحذير راكب الدراجة'
        }
      },
      {
        id: 'q-bi-9o2',
        text: {
          en: 'Slow down and pass with extra caution',
          nl: 'Vertraag en passeer met extra voorzichtigheid',
          ar: 'أبطئ ومر بحذر إضافي'
        }
      },
      {
        id: 'q-bi-9o3',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      }
    ],
    correctAnswerId: 'q-bi-9o2',
    explanation: {
      en: 'When encountering a cyclist without proper lighting at night, slow down and pass with extra caution to ensure safety.',
      nl: 'Bij het tegenkomen van een fietser zonder goede verlichting \'s nachts moet je vertragen en met extra voorzichtigheid passeren om de veiligheid te waarborgen.',
      ar: 'عند مواجهة راكب دراجة بدون إضاءة مناسبة ليلا، أبطئ ومر بحذر إضافي لضمان السلامة.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-10',
    text: {
      en: 'You are driving in a residential area. Children are riding bicycles on the street. What should you do?',
      nl: 'Je rijdt in een woonwijk. Kinderen rijden op fietsen op de straat. Wat moet je doen?',
      ar: 'أنت تقود في منطقة سكنية. الأطفال يركبون دراجات في الشارع. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-10o1',
        text: {
          en: 'Drive normally, children should be careful',
          nl: 'Rijd normaal, kinderen moeten voorzichtig zijn',
          ar: 'اقود بشكل طبيعي، يجب على الأطفال أن يكونوا حذرين'
        }
      },
      {
        id: 'q-bi-10o2',
        text: {
          en: 'Reduce speed and be extra vigilant',
          nl: 'Verminder snelheid en wees extra waakzaam',
          ar: 'قلل السرعة وكن يقظا بشكل إضافي'
        }
      },
      {
        id: 'q-bi-10o3',
        text: {
          en: 'Honk to warn the children',
          nl: 'Toeter om de kinderen te waarschuwen',
          ar: 'استخدم البوق لتحذير الأطفال'
        }
      }
    ],
    correctAnswerId: 'q-bi-10o2',
    explanation: {
      en: 'In residential areas with children cycling, reduce your speed and be extra vigilant as children may not always follow traffic rules.',
      nl: 'In woonwijken waar kinderen fietsen moet je je snelheid verminderen en extra waakzaam zijn omdat kinderen niet altijd de verkeersregels volgen.',
      ar: 'في المناطق السكنية حيث يركب الأطفال الدراجات، قلل سرعتك وكن يقظا بشكل إضافي لأن الأطفال قد لا يتبعون دائما قواعد المرور.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-11',
    text: {
      en: 'You are driving on a road with a shared bicycle and pedestrian path. A cyclist is using the path. What should you do?',
      nl: 'Je rijdt op een weg met een gedeeld fietspad en voetpad. Een fietser gebruikt het pad. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر مشترك للدراجات والمشاة. راكب دراجة يستخدم الممر. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-11o1',
        text: {
          en: 'Ignore the cyclist, they are on a separate path',
          nl: 'Negeer de fietser, ze zijn op een apart pad',
          ar: 'تجاهل راكب الدراجة، هم على ممر منفصل'
        }
      },
      {
        id: 'q-bi-11o2',
        text: {
          en: 'Be aware that the cyclist may enter the road',
          nl: 'Wees je ervan bewust dat de fietser de weg op kan gaan',
          ar: 'كن على علم بأن راكب الدراجة قد يدخل الطريق'
        }
      },
      {
        id: 'q-bi-11o3',
        text: {
          en: 'Honk to warn the cyclist to stay on the path',
          nl: 'Toeter om de fietser te waarschuwen om op het pad te blijven',
          ar: 'استخدم البوق لتحذير راكب الدراجة للبقاء على الممر'
        }
      }
    ],
    correctAnswerId: 'q-bi-11o2',
    explanation: {
      en: 'When driving near shared bicycle and pedestrian paths, be aware that cyclists may need to enter the road and be prepared to give way.',
      nl: 'Bij het rijden nabij gedeelde fietspaden en voetpaden moet je je ervan bewust zijn dat fietsers mogelijk de weg op moeten en bereid zijn om voorrang te verlenen.',
      ar: 'عند القيادة بالقرب من الممرات المشتركة للدراجات والمشاة، كن على علم بأن راكبي الدراجات قد يحتاجون إلى دخول الطريق وكن مستعدا لإعطاء الأولوية.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-12',
    text: {
      en: 'You are driving on a road with a bicycle lane. The bicycle lane is blocked by roadworks. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Het fietspad is geblokkeerd door wegwerkzaamheden. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. ممر الدراجات مسدود بسبب أعمال الطرق. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-12o1',
        text: {
          en: 'Continue driving normally',
          nl: 'Blijf normaal rijden',
          ar: 'استمر في القيادة بشكل طبيعي'
        }
      },
      {
        id: 'q-bi-12o2',
        text: {
          en: 'Be extra careful as cyclists may use the main road',
          nl: 'Wees extra voorzichtig omdat fietsers mogelijk de hoofdweg gebruiken',
          ar: 'كن حذرا بشكل إضافي لأن راكبي الدراجات قد يستخدمون الطريق الرئيسي'
        }
      },
      {
        id: 'q-bi-12o3',
        text: {
          en: 'Honk to warn cyclists about the roadworks',
          nl: 'Toeter om fietsers te waarschuwen voor de wegwerkzaamheden',
          ar: 'استخدم البوق لتحذير راكبي الدراجات بشأن أعمال الطرق'
        }
      }
    ],
    correctAnswerId: 'q-bi-12o2',
    explanation: {
      en: 'When a bicycle lane is blocked, cyclists may need to use the main road. Be extra careful and give them space.',
      nl: 'Wanneer een fietspad geblokkeerd is, moeten fietsers mogelijk de hoofdweg gebruiken. Wees extra voorzichtig en geef ze ruimte.',
      ar: 'عندما يكون ممر الدراجات مسدودا، قد يحتاج راكبو الدراجات إلى استخدام الطريق الرئيسي. كن حذرا بشكل إضافي وأعطهم مساحة.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-13',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding outside the bicycle lane. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt buiten het fietspad. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب خارج ممر الدراجات. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-13o1',
        text: {
          en: 'Honk to make the cyclist use the bicycle lane',
          nl: 'Toeter om de fietser het fietspad te laten gebruiken',
          ar: 'استخدم البوق لجعل راكب الدراجة يستخدم ممر الدراجات'
        }
      },
      {
        id: 'q-bi-13o2',
        text: {
          en: 'Respect the cyclist\'s choice and maintain safe distance',
          nl: 'Respecteer de keuze van de fietser en houd een veilige afstand',
          ar: 'احترم اختيار راكب الدراجة وحافظ على مسافة آمنة'
        }
      },
      {
        id: 'q-bi-13o3',
        text: {
          en: 'Drive as close as possible to force them into the lane',
          nl: 'Rijd zo dicht mogelijk om ze in de rijstrook te dwingen',
          ar: 'اقترب قدر الإمكان لإجبارهم على الدخول إلى الممر'
        }
      }
    ],
    correctAnswerId: 'q-bi-13o2',
    explanation: {
      en: 'Cyclists are not always required to use bicycle lanes. Respect their choice and maintain a safe distance when passing.',
      nl: 'Fietsers zijn niet altijd verplicht om fietspaden te gebruiken. Respecteer hun keuze en houd een veilige afstand bij het passeren.',
      ar: 'راكبو الدراجات ليسوا مطالبين دائما باستخدام ممرات الدراجات. احترم اختيارهم وحافظ على مسافة آمنة عند المرور.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-14',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but swerving slightly. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar zwenkt lichtjes. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه ينحرف قليلا. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-14o1',
        text: {
          en: 'Honk to warn the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتحذير راكب الدراجة'
        }
      },
      {
        id: 'q-bi-14o2',
        text: {
          en: 'Give extra space and pass with caution',
          nl: 'Geef extra ruimte en passeer met voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر'
        }
      },
      {
        id: 'q-bi-14o3',
        text: {
          en: 'Drive as close as possible to keep them in line',
          nl: 'Rijd zo dicht mogelijk om ze op lijn te houden',
          ar: 'اقترب قدر الإمكان لإبقائهم في خط'
        }
      }
    ],
    correctAnswerId: 'q-bi-14o2',
    explanation: {
      en: 'When a cyclist is swerving, they may be avoiding obstacles or have difficulty maintaining balance. Give extra space and pass with caution.',
      nl: 'Wanneer een fietser zwenkt, vermijdt hij mogelijk obstakels of heeft hij moeite met het behouden van balans. Geef extra ruimte en passeer met voorzichtigheid.',
      ar: 'عندما ينحرف راكب الدراجة، قد يكون يتجنب العوائق أو يواجه صعوبة في الحفاظ على التوازن. أعط مساحة إضافية ومر بحذر.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-15',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but appears to be looking at their phone. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar lijkt naar zijn telefoon te kijken. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه يبدو أنه ينظر إلى هاتفه. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-15o1',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      },
      {
        id: 'q-bi-15o2',
        text: {
          en: 'Give extra space and pass with caution',
          nl: 'Geef extra ruimte en passeer met voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر'
        }
      },
      {
        id: 'q-bi-15o3',
        text: {
          en: 'Drive as close as possible to get their attention',
          nl: 'Rijd zo dicht mogelijk om hun aandacht te trekken',
          ar: 'اقترب قدر الإمكان لجذب انتباههم'
        }
      }
    ],
    correctAnswerId: 'q-bi-15o2',
    explanation: {
      en: 'When a cyclist appears distracted, give extra space and pass with caution. Honking may startle them and cause an accident.',
      nl: 'Wanneer een fietser afgeleid lijkt, geef extra ruimte en passeer met voorzichtigheid. Toeteren kan hen laten schrikken en een ongeval veroorzaken.',
      ar: 'عندما يبدو راكب الدراجة مشتتا، أعط مساحة إضافية ومر بحذر. استخدام البوق قد يفزعهم ويسبب حادثا.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-16',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but appears to be intoxicated. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar lijkt dronken te zijn. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه يبدو أنه مخمور. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-16o1',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      },
      {
        id: 'q-bi-16o2',
        text: {
          en: 'Give extra space and pass with extreme caution',
          nl: 'Geef extra ruimte en passeer met extreme voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر شديد'
        }
      },
      {
        id: 'q-bi-16o3',
        text: {
          en: 'Drive as close as possible to keep them in line',
          nl: 'Rijd zo dicht mogelijk om ze op lijn te houden',
          ar: 'اقترب قدر الإمكان لإبقائهم في خط'
        }
      }
    ],
    correctAnswerId: 'q-bi-16o2',
    explanation: {
      en: 'When a cyclist appears intoxicated, give extra space and pass with extreme caution. Their behavior may be unpredictable.',
      nl: 'Wanneer een fietser dronken lijkt, geef extra ruimte en passeer met extreme voorzichtigheid. Hun gedrag kan onvoorspelbaar zijn.',
      ar: 'عندما يبدو راكب الدراجة مخمورا، أعط مساحة إضافية ومر بحذر شديد. قد يكون سلوكهم غير متوقع.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-17',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but appears to be having mechanical problems. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar lijkt mechanische problemen te hebben. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه يبدو أنه يواجه مشاكل ميكانيكية. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-17o1',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      },
      {
        id: 'q-bi-17o2',
        text: {
          en: 'Give extra space and pass with caution',
          nl: 'Geef extra ruimte en passeer met voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر'
        }
      },
      {
        id: 'q-bi-17o3',
        text: {
          en: 'Drive as close as possible to keep them moving',
          nl: 'Rijd zo dicht mogelijk om ze in beweging te houden',
          ar: 'اقترب قدر الإمكان لإبقائهم متحركين'
        }
      }
    ],
    correctAnswerId: 'q-bi-17o2',
    explanation: {
      en: 'When a cyclist appears to have mechanical problems, give extra space and pass with caution as they may need to stop suddenly.',
      nl: 'Wanneer een fietser mechanische problemen lijkt te hebben, geef extra ruimte en passeer met voorzichtigheid omdat ze mogelijk plotseling moeten stoppen.',
      ar: 'عندما يبدو أن راكب الدراجة يواجه مشاكل ميكانيكية، أعط مساحة إضافية ومر بحذر لأنهم قد يحتاجون إلى التوقف فجأة.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-18',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but appears to be lost or confused. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar lijkt verdwaald of verward te zijn. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه يبدو أنه تائه أو مرتبك. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-18o1',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      },
      {
        id: 'q-bi-18o2',
        text: {
          en: 'Give extra space and pass with caution',
          nl: 'Geef extra ruimte en passeer met voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر'
        }
      },
      {
        id: 'q-bi-18o3',
        text: {
          en: 'Drive as close as possible to guide them',
          nl: 'Rijd zo dicht mogelijk om ze te begeleiden',
          ar: 'اقترب قدر الإمكان لإرشادهم'
        }
      }
    ],
    correctAnswerId: 'q-bi-18o2',
    explanation: {
      en: 'When a cyclist appears lost or confused, give extra space and pass with caution as they may make unexpected movements.',
      nl: 'Wanneer een fietser verdwaald of verward lijkt, geef extra ruimte en passeer met voorzichtigheid omdat ze mogelijk onverwachte bewegingen kunnen maken.',
      ar: 'عندما يبدو راكب الدراجة تائها أو مرتبكا، أعط مساحة إضافية ومر بحذر لأنهم قد يقومون بحركات غير متوقعة.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-19',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but appears to be in distress. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar lijkt in nood te zijn. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه يبدو أنه في محنة. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-19o1',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      },
      {
        id: 'q-bi-19o2',
        text: {
          en: 'Give extra space and pass with caution',
          nl: 'Geef extra ruimte en passeer met voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر'
        }
      },
      {
        id: 'q-bi-19o3',
        text: {
          en: 'Stop and offer help if safe to do so',
          nl: 'Stop en bied hulp aan als het veilig is',
          ar: 'توقف وعرض المساعدة إذا كان ذلك آمنا'
        }
      }
    ],
    correctAnswerId: 'q-bi-19o3',
    explanation: {
      en: 'When a cyclist appears to be in distress, stop and offer help if it is safe to do so. Otherwise, give extra space and pass with caution.',
      nl: 'Wanneer een fietser in nood lijkt te zijn, stop en bied hulp aan als het veilig is om dat te doen. Anders, geef extra ruimte en passeer met voorzichtigheid.',
      ar: 'عندما يبدو أن راكب الدراجة في محنة، توقف وعرض المساعدة إذا كان ذلك آمنا. خلاف ذلك، أعط مساحة إضافية ومر بحذر.'
    },
    subject: 'Bicycle Interactions'
  },
  {
    id: 'q-bi-20',
    text: {
      en: 'You are driving on a road with a bicycle lane. A cyclist is riding in the bicycle lane but appears to be racing. What should you do?',
      nl: 'Je rijdt op een weg met een fietspad. Een fietser rijdt op het fietspad maar lijkt te racen. Wat moet je doen?',
      ar: 'أنت تقود على طريق به ممر دراجات. راكب دراجة يركب في ممر الدراجات لكنه يبدو أنه يسبق. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-bi-20o1',
        text: {
          en: 'Honk to alert the cyclist',
          nl: 'Toeter om de fietser te waarschuwen',
          ar: 'استخدم البوق لتنبيه راكب الدراجة'
        }
      },
      {
        id: 'q-bi-20o2',
        text: {
          en: 'Give extra space and pass with caution',
          nl: 'Geef extra ruimte en passeer met voorzichtigheid',
          ar: 'أعط مساحة إضافية ومر بحذر'
        }
      },
      {
        id: 'q-bi-20o3',
        text: {
          en: 'Drive as close as possible to keep them in line',
          nl: 'Rijd zo dicht mogelijk om ze op lijn te houden',
          ar: 'اقترب قدر الإمكان لإبقائهم في خط'
        }
      }
    ],
    correctAnswerId: 'q-bi-20o2',
    explanation: {
      en: 'When a cyclist appears to be racing, give extra space and pass with caution as their behavior may be unpredictable.',
      nl: 'Wanneer een fietser lijkt te racen, geef extra ruimte en passeer met voorzichtigheid omdat hun gedrag onvoorspelbaar kan zijn.',
      ar: 'عندما يبدو أن راكب الدراجة يسبق، أعط مساحة إضافية ومر بحذر لأن سلوكهم قد يكون غير متوقع.'
    },
    subject: 'Bicycle Interactions'
  }
];

























